






























import {Vue, Component, Ref, Prop, PropSync} from 'vue-property-decorator';
import { CollapseTransition } from "vue2-transitions";
import {notifyError} from "@/utils/notify-helper";

@Component({components: {CollapseTransition}})
export default class SaveTemplate extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;

  name = null

  async onConfirm() {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return
    }
    this.$emit('confirm', this.name)
    this.name = null
    // this.is_show = false
  }

}
